// extracted by mini-css-extract-plugin
export default {"root":"logo_root__OetpQ","placeHolderShimmer":"logo_placeHolderShimmer__NVD2X"};